// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24SAF","toggle":"styles_toggle__3348c","preview":"styles_preview__2xSIu"};